<template>

	<div>
        
		<div class="row">
			<div class="col-md-4">
                <svg width="123" height="123" viewBox="0 0 123 123">
					<rect x="0.580078" y="0.890137" width="121.749" height="121.749" rx="8" style="fill:#dbdee0" />
					<text x="22" y="65" fill="#757778" style="font-weight: 700;font-size:18px;opacity:80%">No Image</text>
				</svg>
            </div>
			<div class="col-8">
				<h5 class="mt-3 text-dark" style="color:black !important">{{org_data.name}} {{getOrganization}}</h5>
				<p class="text-dark" style="color:black !important"></p>
			</div>
		</div>
		<hr class="mb-2">
		<ul class="nav nav-pills nav-fill" role="tablist" id="tabs" style="font-size:14px;font-weight:500;">
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==1 ? 'active' : '']" @click="tabs(1)">Informations</button>
			</li>
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==2 ? 'active' : '']" @click="tabs(2)">Customer Settings</button>
			</li>
			<!--<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==3 ? 'active' : '']" @click="tabs(3)">Demo Notes</button>
			</li>
			<li>
				<button style="padding: 5px 10px;" class="rounded mt-1" v-bind:class="[ tab==4 ? 'active' : '']" @click="tabs(4)">Notes</button>
			</li> -->
		</ul>
		<hr>

		<!-- Informations -->
		<div v-if="tab==1">
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Organization Name:</span>
						<br>
						<span style="color:black">{{org_data.name}}</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Username:</span>
						<br>
						<span style="color:black">{{formData.product == 1 ? org_data.db_name : org_data.careerportal_prefix}}</span>
					</div>
				</div>
			</div>
            <div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Email:</span>
						<br>
						<span style="color:black">{{org_data.email}}</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Address:</span>
						<br>
						<span style="color:black">{{org_data.street_address}}</span>
					</div>
				</div>
			</div>
			
		</div>

		<div v-if="tab==2">

			<div v-if="limit_driver_users">
				<h6 class="customer_setting_headings">The number of driver users for this organization.</h6>
				{{limit_driver_users}}
				
				<h6 class="customer_setting_headings">Is this organization allow to send SMS.</h6>
				<div v-if="send_sms_to_contacts == 1">
					<span>Yes</span>
				</div>
				<div v-else-if="send_sms_to_contacts == 0">
					<span >No</span>
				</div>
			</div>

			<div v-else-if="!limit_driver_users">
				<div><div class="text-center"><h4 class="my-5 py-5">No Content</h4></div></div>
			</div>
		</div>

	</div>
</template>
<script>
	import axios from 'axios';
	import moment from 'moment';

	Vue.filter('formatDate', function (value) {
		if (value != '0000-00-00 00:00:00' && value != null) {
			return moment(String(value)).format('MMM DD, Y LT')
		}
	});
	export default {
		props: [
			'action', 'formData'
		],
		data: function () {
			return {
				tab: 1,
                org_data:'',
                info:'',
				limit_driver_users:'',
                send_sms_to_contacts:"",
                flag:true,
				
			};
		},
		
    created: function () {
      axios.get('/admin/organization/getorgdetail?org_id=' + this.formData.org_id + '&product=' + this.formData.product)
					.then((response) => {
						let data = response.data.data;
                        let detailinfo = response.data.info;
						this.tab = 1;
						if (data != null) {
							this.org_data = data;
                            
						}
						
					});
    },
    computed: {
            getOrganization: function () {
				axios.get('/admin/organization/getorgdetail?org_id=' + this.formData.org_id + '&product=' + this.formData.product)
					.then((response) => {
						let data = response.data.data;
                        let detailinfo = response.data.info;
						this.tab = 1;
						if (data != null) {
							this.org_data = data;
                            
						}
						
					});
			},
                
        },
		methods: {
			tabs(event) {
				if (event == 1) {
					this.tab = 1;
				} else if (event == 2) {
					this.tab = 2;
					
					axios.get('admin/organization/settings/' + this.formData.org_id)
						.then((response) => {
						let res = response.data.data;
						if (res != null) {
							this.limit_driver_users = res.limit_driver_users;
							this.send_sms_to_contacts = res.send_sms_to_contacts;
						}else{
							
							this.limit_driver_users = "";
							this.send_sms_to_contacts = "";
						}
						this.flag = true;
                	});

				} else if (event == 3) {
					this.tab = 3;
				}
				else if (event == 4) {
					this.tab = 4;
				}
			},

            

            
		}
	}
</script>
<style scoped>
	#tabs .nav-link {
		background: transparent;
		color: rgb(66, 64, 64);
	}

	#tabs a:hover {}

	#tabs .active {
		background-color: #48a6a6 !important;
		color: white;
	}


	/* (A) "SET" THE TIMELINE CONTAINER */
	.vtl {
		/* (A1) RELATIVE POSITION NECESSARY TO PROPERLY POSITION TIMELINE LATER */
		position: relative;
		/* (A2) RESERVE MORE SPACE TO THE LEFT FOR THE TIMELINE */
		padding: 10px 0px 10px 50px;
		/* (A3) OPTIONAL WIDTH RESTRICTION */
		max-width: 1000px;
	}

	/* (B) DRAW TIMELINE USING ::BEFORE */
	.vtl::before {
		/* (B1) DRAW THE TIMELINE */
		content: '';
		width: 3px;
		background-color: #f4f8fa;
		/* (B2) POSITION IT TO THE LEFT */
		position: absolute;
		top: 0;
		bottom: 0;
		left: 15px;
	}

	/* (C) STYLES FOR THE EVENTS */
	div.event {
		padding: 20px 30px;
		background-color: #f2f5f7;
		position: relative;
		border-radius: 6px;
		margin-bottom: 10px;
	}

	/* (D) STYLES FOR THE DATE & TEXT */
	strong.edate {
		font-size: 14px;
		font-weight: bold;
		color: #48a6a6;
	}

	p.etxt {
		margin: 10px 0 0 0;
		color: #222;
	}

	/* (E) ADD "SPEECH BUBBLE TRIANGLE" TO THE EVENTS */
	div.event::before {
		content: '';
		border: 10px solid transparent;
		border-right-color: #f2f5f7;
		border-left: 0;
		position: absolute;
		top: 20%;
		left: -10px;
	}
	p.no_record{
		text-align: center;
	}
	h6.customer_setting_headings{
		margin-top: 24px;
	}

	/* (F) ADD A CIRCLE ON THE TIMELINE TO INDICATE AN EVENT */
	div.event::after {
		content: '';
		background: #f4f8fa;
		border: 4px solid #48a6a6;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		position: absolute;
		top: 25%;
		left: -40px;
	}
</style>